import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
})(action('selectHideDeletedItemsOption')(function selectHideDeletedItemsOption(hideDeletedItems, state) {
    var optionState = state.optionState;
    optionState.hideDeletedItems = hideDeletedItems;
}));
//# sourceMappingURL=selectHideDeletedItemsOption.js.map